import React from 'react';
import { connect } from 'react-redux';
import { LabeledCheckbox } from 'components/shared/checkbox';
import Table from '../table';
import { bulkActionsToggleItem } from '../../../actions/shared/index/bulk_core';
import {
  isItemSelectedSelector,
  isLoading,
  shouldDisableContentCheckboxes,
} from '../../../selectors';

const IndexTableRow = props => (
  <Table.Row selected={props.selected}>
    {props.selectable && (
      <Table.BodyCell size="xs">
        <LabeledCheckbox
          checked={props.selected}
          disabled={props.disabled || props.checkBoxDisabled}
          onChange={e => props.toggleItem(props.index)}
          className="u-margin-0"
          ariaLabel={t('common.select')}
        />
      </Table.BodyCell>
    )}
    {props.children}
  </Table.Row>
);

const mapStateToProps = () => {
  const isSelected = isItemSelectedSelector();
  return (state, { index, selectable }) => ({
    disabled:
      selectable && (isLoading(state) || shouldDisableContentCheckboxes(state)),
    selected: selectable && isSelected(state, index),
  });
};

const mapDispatchToProps = dispatch => ({
  toggleItem(index) {
    dispatch(bulkActionsToggleItem(index));
  },
});

const ConnectedIndexTableRow = connect(
  mapStateToProps,
  mapDispatchToProps,
)(IndexTableRow);

ConnectedIndexTableRow.defaultProps = {
  selectable: true,
};

export default ConnectedIndexTableRow;
